let globalIsMetric = true;  // Global state for metric/imperial

function initializeUnitToggle() {
  const sizeValueElement = document.getElementById('size-value');
  const toggleCheckbox = document.getElementById('unique-toggle-size');
  
  if (!sizeValueElement || !toggleCheckbox) {
    console.log('Elements not found, retrying in 100ms');
    setTimeout(initializeUnitToggle, 100);
    return;
  }
  
  // Remove any existing event listeners
  toggleCheckbox.removeEventListener('change', handleToggleChange);
  
  // Set initial toggle state to CM (unchecked)
  toggleCheckbox.checked = !globalIsMetric;

  const convertDimensions = (size, toInches = true) => {
    if (!size) return '';
    
    const cmRegex = /^([\d.]+)\s*x\s*([\d.]+)\s*(cm|xm)?$/i;
    const inRegex = /^([\d.]+)\s*x\s*([\d.]+)\s*in$/i;
    const diameterCmRegex = /^Ø\s*([\d.]+)\s*(cm|xm)?$/i;
    const diameterInRegex = /^Ø\s*([\d.]+)\s*in$/i;
    const diameterXLengthCmRegex = /^Ø\s*([\d.]+)\s*x\s*([\d.]+)\s*(cm|xm)?$/i;
    const diameterXLengthInRegex = /^Ø\s*([\d.]+)\s*x\s*([\d.]+)\s*in$/i;

    const matchCm = size.match(cmRegex);
    const matchIn = size.match(inRegex);
    const matchDiameterCm = size.match(diameterCmRegex);
    const matchDiameterIn = size.match(diameterInRegex);
    const matchDiameterXLengthCm = size.match(diameterXLengthCmRegex);
    const matchDiameterXLengthIn = size.match(diameterXLengthInRegex);

    if (toInches && matchCm) {
      const width = Math.round(parseFloat(matchCm[1]) * 0.393701 * 100) / 100;
      const height = Math.round(parseFloat(matchCm[2]) * 0.393701 * 100) / 100;
      return `${width}x${height} in`;
    } else if (!toInches && matchIn) {
      const width = Math.round(parseFloat(matchIn[1]) / 0.393701 * 10) / 10;
      const height = Math.round(parseFloat(matchIn[2]) / 0.393701 * 10) / 10;
      return `${width}x${height} cm`;
    } else if (toInches && matchDiameterCm) {
      const diameterCm = parseFloat(matchDiameterCm[1]);
      const diameterIn = Math.round(diameterCm * 0.393701 * 100) / 100;
      return `Ø${diameterIn} in`;
    } else if (!toInches && matchDiameterIn) {
      const diameterIn = parseFloat(matchDiameterIn[1]);
      const diameterCm = Math.round(diameterIn / 0.393701 * 10) / 10;
      return `Ø${diameterCm} cm`;
    } else if (toInches && matchDiameterXLengthCm) {
      const diameterCm = parseFloat(matchDiameterXLengthCm[1]);
      const lengthCm = parseFloat(matchDiameterXLengthCm[2]);
      const diameterIn = Math.round(diameterCm * 0.393701 * 100) / 100;
      const lengthIn = Math.round(lengthCm * 0.393701 * 100) / 100;
      return `Ø${diameterIn} x ${lengthIn} in`;
    } else if (!toInches && matchDiameterXLengthIn) {
      const diameterIn = parseFloat(matchDiameterXLengthIn[1]);
      const lengthIn = parseFloat(matchDiameterXLengthIn[2]);
      const diameterCm = Math.round(diameterIn / 0.393701 * 10) / 10;
      const lengthCm = Math.round(lengthIn / 0.393701 * 10) / 10;
      return `Ø${diameterCm} x ${lengthCm} cm`;
    }

    return size;
  };

  function handleToggleChange(event) {
    event.preventDefault();
    globalIsMetric = !globalIsMetric;
    
    let currentSize = sizeValueElement.textContent.trim();
    if (!globalIsMetric) {
      let convertedSize = convertDimensions(currentSize, true);
      sizeValueElement.textContent = convertedSize;
    } else {
      let convertedSize = convertDimensions(currentSize, false);
      sizeValueElement.textContent = convertedSize;
    }
  }

  // Add event listener with named function so we can remove it if needed
  toggleCheckbox.addEventListener('change', handleToggleChange);

  // Initialize the size based on current state
  if (!globalIsMetric) {
    let currentSize = sizeValueElement.textContent.trim();
    let convertedSize = convertDimensions(currentSize, true);
    sizeValueElement.textContent = convertedSize;
  }

  // Create a mutation observer to watch for changes to the size value
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        setTimeout(() => {
          const sizeValueElement = document.getElementById('size-value');
          if (sizeValueElement && !globalIsMetric) {
            let currentSize = sizeValueElement.textContent.trim();
            let convertedSize = convertDimensions(currentSize, true);
            sizeValueElement.textContent = convertedSize;
          }
        }, 100);
      }
    });
  });

  // Start observing the size value element
  observer.observe(sizeValueElement, {
    childList: true,
    characterData: true,
    subtree: true
  });

  // Listen for variant changes
  document.addEventListener('variant:changed', function() {
    setTimeout(() => {
      const sizeValueElement = document.getElementById('size-value');
      if (sizeValueElement && !globalIsMetric) {
        let currentSize = sizeValueElement.textContent.trim();
        let convertedSize = convertDimensions(currentSize, true);
        sizeValueElement.textContent = convertedSize;
      }
    }, 400);
  });
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', function() {
  globalIsMetric = true;  // Reset to CM on page load
  setTimeout(initializeUnitToggle, 100);
});

// Re-initialize when the section is reloaded by Shopify
document.addEventListener('shopify:section:load', function() {
  setTimeout(initializeUnitToggle, 100);
});

// Also initialize when quick view or other dynamic content is loaded
document.addEventListener('quickview:loaded', function() {
  setTimeout(initializeUnitToggle, 100);
});

// Re-initialize after variant changes
document.addEventListener('variant:changed', function() {
  setTimeout(initializeUnitToggle, 400);
}); 